import { PhotosReceiveUnverifiedPhotosReducer } from './types';

export const photosReceiveUnverifiedPhotosReducer: PhotosReceiveUnverifiedPhotosReducer =
  (state, action) => {
    const { unverifiedPhotos } = action.payload;

    return {
      ...state,
      unverifiedPhotos: [
        ...(state.unverifiedPhotos || []),
        ...unverifiedPhotos,
      ],
    };
  };
